import Create from "./Create";
import Detail from "./Detail";
import List from "./List";
import OrderSearch from "./OrderSearch";

const routes = [
    {
        path: 'orders/create/:orderId',
        element: <Create />
    },
    {
        path: 'orders',
        element: <List />
    },
    {
        path: 'orders/searchOrder',
        element: <OrderSearch />
    },
    {
        path: 'orders/:orderId',
        element: <Detail />
    },
]
export default routes;